<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui';
  import CheckMarkIcon from '@/shared/assets/icons/CheckMarkIcon.svg';

  const props = withDefaults(
    defineProps<{
      canSave: boolean;
      isSaving: boolean;
      blockedReason?: string | null;
    }>(),
    { blockedReason: null }
  );

  const emit = defineEmits<{
    cancel: [];
    save: [];
  }>();
</script>

<template>
  <div class="flex items-center justify-end gap-6 px-8 py-8" data-testid="record-config-actions">
    <p
      v-if="props.blockedReason !== null"
      class="text-sm text-gray-05"
      data-testid="record-config-blocked-reason"
    >
      {{ props.blockedReason }}
    </p>
    <ColoredButton
      outlined
      color="gray-07"
      border-color="gray-02"
      text="Cancelar"
      :disabled="props.isSaving"
      data-testid="record-config-cancel"
      @click="emit('cancel')"
    />
    <ColoredButton
      :icon="CheckMarkIcon"
      icon-alt=""
      text="Salvar"
      :disabled="!props.canSave || props.isSaving"
      :loading="props.isSaving"
      data-testid="record-config-save"
      @click="emit('save')"
    />
  </div>
</template>
